<template> 
  <div class="card">
    <div class="card-header">
      <h4 class="card-header">Tutorial</h4>
    </div>
    <!-- general tex rule -->
    <div class="card-body user-select-none">
      <!-- step 1 -->
      <h5 class="card-title badge shadow p-2 mb-5 bg-white rounded d-inline p-2 bd-highlight justify-content-center" style="width: 300px; height: 34px;">Step 1: Select your molecule.</h5>
      <ol class="card-text">
        <li>On the top left, choose between
          <p class="badge badge-pill badge-primary d-inline p-2 justify-content-center">DNA</p>
          or
          <p class="badge badge-pill badge-primary d-inline p-2 justify-content-center">PROTEIN</p>
          according to your requirements.
        </li>
      </ol>
      <!-- step 2 -->
      <h5 class="card-title badge shadow p-2 mb-5 bg-white rounded d-inline p-2 bd-highlight justify-content-center" style="width: 300px; height: 34px;">Step 2: Enter your sequence.</h5>
      <ol class="card-text">
        <li>Paste or type your query sequence in the box.</li>
        <li>Select the musical instrument of your choice and press the
          <pre class="badge badge-primary d-inline p-2 justify-content-center" id="tempo">PLAY</pre> button. Optionally, you can adjust the music speed in "<u>Set Tempo</u>" option;
        </li>
        <li>You can stop playing the song at any time by pressing the 
          <pre class="badge badge-danger d-inline p-2 justify-content-center">STOP</pre> button;
        </li>
        <li>Use the 
          <pre class="badge badge-info d-inline p-2 justify-content-center">CLEAR</pre> button to delete the previous sequence in the box and insert a new one;
        </li>
        <li>Experienced users can change the notes of the aminoacids with the "<u>Tune the Amino acids</u>" option.
          Use the <pre class="badge badge-info d-inline p-2 justify-content-center">Default</pre> button to return to the initial values.</li>
      </ol>
    </div>
    <!-- sound examples -->
    <!-- <div class="card-header">
      <h4 class="card-header">Sound Examples</h4>
      <div class="card-text form-group">
        <p>
          <i class="image btn btn-link" @click.prevent="playSound1('audio/GAATTC.wav')">
            <span><img src="images/play_circle_outline-black-36dp.svg"></span>
          </i>
          <em>EcoRI</em> → GAATTC
        </p>
        <p>
          <i class="image btn btn-link" @click.prevent="playSound2('audio/AAGCTT.wav')">
            <span><img src="images/play_circle_outline-black-36dp.svg"></span>
          </i>
          <em>HindIII</em> → AAGCTT
        </p>
        <p>
          <i class="image btn btn-link" @click.prevent="playSound3('audio/GGATCC.wav')">
            <span><img src="images/play_circle_outline-black-36dp.svg"></span>
          </i>
          <em>BamHI</em> → GGATCC
        </p>
        <p>
          <i class="image btn btn-link" @click.prevent="playSound4('audio/CCATGG.wav')">
            <span><img src="images/play_circle_outline-black-36dp.svg"></span>
          </i>
          <em>Ncol</em> → CCATGG
        </p>
        <p>
          <i class="image btn btn-link" @click.prevent="playSound5('audio/Proximity1a.wav')">
            <span><img src="images/play_circle_outline-black-36dp.svg"></span>
          </i>
          CpG Island
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>
  export default {

    methods: {
      playSound1(sound) {
        if(sound) {
          var audio = new Audio(sound);
          audio.play();
          console.log("Playing the arpeggio");
        }
      },
      playSound2(sound) {
        if(sound) {
          var audio = new Audio(sound);
          audio.play();
          console.log("Playing the arpeggio");
        }
      },
      playSound3(sound) {
        if(sound) {
          var audio = new Audio(sound);
          audio.play();
          console.log("Playing the arpeggio");
        }
      },
      playSound4(sound) {
        if(sound) {
          var audio = new Audio(sound);
          audio.play();
          console.log("Playing the arpeggio");
        }
      },
      playSound5(sound) {
        if(sound) {
          var audio = new Audio(sound);
          audio.play();
          console.log("Playing the arpeggio");
        }
      },
    },
  }
</script>

<style scoped>

.card-title {
  font-size: 16px;
}

.card-text {
    margin-top: 30px;
    margin-bottom: 20px;
    line-height: 50px;
    list-style-position: inside;
    text-align: justify;
}

.card {
  text-align: center;
}

.image {
  display: inline-block;
  margin-right: 10px;
}

</style>